module.exports = __webpack_public_path__ + "media/images/bezorgen-3e144df9d1d15bfc5471012007b7bbe9.png";